"use strict";
//
// Copyright © 2026 Intabia Fusion.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.YandexMetrikaProvider = void 0;
class YandexMetrikaProvider {
    counterId;
    init(config) {
        const id = config.YANDEX_METRIKA_ID;
        if (id === null || id === '')
            return false;
        this.counterId = typeof id === 'string' ? parseInt(id, 10) : id;
        if (this.counterId === undefined || isNaN(this.counterId))
            return false;
        // Only load script immediately if we land directly on a tracking path
        if (typeof window !== 'undefined') {
            const path = window.location.pathname;
            if (this.isTrackingPath(path)) {
                this.loadMetrika();
                window.ym(this.counterId, 'hit', window.location.href, {
                    referer: document.referrer,
                    title: document.title
                });
            }
        }
        return true;
    }
    isTrackingPath(path) {
        if (path.includes('/selectWorkspace') || path.includes('/workbench'))
            return false;
        return (path.includes('/login') ||
            path.includes('/signup') ||
            path.includes('/join') ||
            path.includes('/createWorkspace') ||
            path.includes('/onboard'));
    }
    loadMetrika() {
        if (typeof window === 'undefined')
            return;
        const scriptUrl = 'https://mc.yandex.ru/metrika/tag.js';
        const scripts = document.getElementsByTagName('script');
        let alreadyLoaded = false;
        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].src.includes('mc.yandex.ru/metrika/tag.js')) {
                alreadyLoaded = true;
                break;
            }
        }
        if (!alreadyLoaded) {
            if (window.ym === undefined || window.ym === null) {
                const ymQueue = [];
                const ymFunc = function () {
                    // eslint-disable-next-line prefer-rest-params
                    ymQueue.push(arguments);
                };
                ymFunc.a = ymQueue;
                window.ym = ymFunc;
            }
            window.ym.l = Date.now();
            const script = document.createElement('script');
            script.async = true;
            script.src = scriptUrl;
            const firstScript = document.getElementsByTagName('script')[0];
            if (firstScript !== undefined && firstScript !== null) {
                const parent = firstScript.parentNode;
                if (parent !== null && parent !== undefined) {
                    parent.insertBefore(script, firstScript);
                }
                else {
                    document.head.appendChild(script);
                }
            }
            else {
                document.head.appendChild(script);
            }
        }
        if (this.counterId !== undefined) {
            window.ym(this.counterId, 'init', {
                clickmap: false,
                trackLinks: false,
                accurateTrackBounce: false,
                webvisor: false,
                defer: true
            });
        }
    }
    unloadMetrika() {
        if (typeof window === 'undefined')
            return;
        const scripts = document.getElementsByTagName('script');
        for (let i = 0; i < scripts.length; i++) {
            const script = scripts[i];
            if (script.src.includes('mc.yandex.ru/metrika/tag.js')) {
                const parent = script.parentNode;
                if (parent !== null && parent !== undefined) {
                    parent.removeChild(script);
                }
                break;
            }
        }
        try {
            delete window.ym;
            delete window.Ya;
            delete window.yandex_metrika_callbacks;
            delete window.yandex_metrika_callbacks2;
        }
        catch (e) {
            window.ym = undefined;
        }
    }
    setUser(email, data) { }
    setAlias(distinctId, alias) { }
    setTag(key, value) { }
    setWorkspace(ws, guest) { }
    handleEvent(event, params = {}) {
        if (typeof window === 'undefined' || this.counterId === undefined || window.ym === undefined)
            return;
        // 1) Submitted form with registration data (either standard email or OTP code success validation)
        if ((event === 'signup.viaEmail' || event === 'signup.viaOtp') && params?.ok === true) {
            let method = 'email';
            if (event === 'signup.viaOtp') {
                method = 'otp';
            }
            const isInvite = window.location.pathname.includes('/join');
            window.ym(this.counterId, 'reachGoal', 'signup_submit', { method, invite: isInvite });
        }
        else if (event.startsWith('signup.') && event.endsWith('.completed')) {
            const split = event.split('.');
            const method = split[1] !== undefined && split[1] !== '' ? split[1] : 'oauth';
            const isInvite = window.location.pathname.includes('/join');
            window.ym(this.counterId, 'reachGoal', 'signup_submit', { method, invite: isInvite });
        }
        // 2) Created space
        if (event === 'onboard.createWorkspace' && params?.ok === true) {
            window.ym(this.counterId, 'reachGoal', 'workspace_created');
        }
    }
    handleError(_error) { }
    navigate(path) {
        if (typeof window === 'undefined' || this.counterId === undefined)
            return;
        // Lazy load the script and track hit only when visiting a tracking page
        if (this.isTrackingPath(path)) {
            this.loadMetrika();
            if (window.ym !== undefined) {
                let fullUrl;
                try {
                    fullUrl = new URL(path, window.location.origin).href;
                }
                catch {
                    fullUrl = path;
                }
                window.ym(this.counterId, 'hit', fullUrl, {
                    referer: document.referrer,
                    title: document.title
                });
            }
        }
        else if (path.includes('/workbench')) {
            // Delay unloading by 3 seconds to make sure that the network requests
            // for any pending goals/hits are dispatched successfully by the browser.
            setTimeout(() => {
                if (typeof window !== 'undefined' && window.location.pathname.includes('/workbench')) {
                    this.unloadMetrika();
                }
            }, 3000);
        }
    }
    logout() { }
}
exports.YandexMetrikaProvider = YandexMetrikaProvider;
//# sourceMappingURL=yandexMetrika.js.map